import React from 'react'
import styled from '@emotion/styled'
import { mq } from '../../helpers'
import { Text } from '../../styles/Components'
import { kebabCase } from 'lodash'

const ServiceBarWrapper = styled.div`
  box-sizing: border-box;
  max-width: 1600px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: white;
  position: sticky;
  top: 60px;
  overflow-x: auto;

  ${mq('max', '768px')} {
    overflow-x: scroll;
    padding: 21px 0;
    width: 100%;
  }

  .services-bar-content {
    box-sizing: border-box;
    width: 100%;
    max-width: 1600px;
    justify-content: space-between;
    display: flex;
    gap: 50px;

    .markets {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 11px;

      p:first-child {
        white-space: nowrap;
      }
    }

    .services {
      display: flex;
      gap: 50px;
      align-items: center;

      ${mq('max', '1280px')} {
        gap: 25px;
      }

      ${mq('max', '1024px')} {
        gap: 16px;
      }

      .selected {
        border-bottom: 2px solid black;
      }

      .service-container {
        flex: 0 0 auto;

        div {
          p {
            &:hover { 
              cursor: pointer;
            }
          }
        }
      }
    }
  }

`

export const ServiceTypeBar = ({ services, selectedTab }) => {
  const handleClick = (event) => {
    // kebabCase to handle 2 word service names
    const hashId = kebabCase(event.target.id.toLowerCase())
    const target = document.querySelector(`#${hashId}`)

    if (target) {
      // padding accounts for sticky book bar
      const paddingTop = 250
      const targetPosition = target.getBoundingClientRect().top + window.scrollY
      window.scrollTo({ top: targetPosition - paddingTop, behavior: "smooth" })
    }
  }

  return (
    <ServiceBarWrapper>
      <div className='services-bar-content'>
        <div className='services'>
          {Object.keys(services).map(service => (
            <div className={`service-container ${selectedTab === kebabCase(service.toLowerCase()) ? 'selected' : '' }`} key={service}>
              <div 
                role='button'
                onClick={handleClick}
              >
                <Text margin='10px 0' id={service} variant='medium'>{service}</Text>
              </div>
            </div>
          ))}
        </div>
      </div>
    </ServiceBarWrapper>
  )
}
